<template>
    <div>
      <information-facture-rapprochement :facture="dcf"></information-facture-rapprochement>
      <montant-rapprochement :facture="dcf" :commandeAchatARapprocher="commandeAchatRapprocher"
                             :isVisualisation="true"
                             class="mgt-20px"></montant-rapprochement>
      <commande-achat-a-rapprocher
          :moduleType="moduleType"
          :facture="dcf"
          :isVisualisation="true"
          :commandeAchatARapprocher="commandeAchatRapprocher"
          class="mgt-20px"></commande-achat-a-rapprocher>
    </div>
</template>

<script>
import informationFactureRapprochement
  from '@/components/baux/factureAchatARapprocher/edition/rapprochement/informationFactureRapprochement';
import montantRapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/montantRapprochement';
import commandeAchatARapprocher
  from '@/components/baux/factureAchatARapprocher/edition/rapprochement/commandeAchatARapprocher';

export default {
  props: {
    dcf: {
      type: Object,
      required: true,
    },
    commandeAchatRapprocher: {
      type: Array,
      required: true,
    },
    moduleType: {
      type: String,
      required: true,
    },
  },
  components: {
    informationFactureRapprochement,
    montantRapprochement,
    commandeAchatARapprocher,
  },
};
</script>

<style scoped>

</style>
